var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:lock-small-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0004 8.80078V9.73678C16.4685 9.90229 16.8738 10.2089 17.1603 10.6144C17.4469 11.0199 17.6007 11.5043 17.6004 12.0008V16.8008C17.6004 17.4373 17.3475 18.0477 16.8974 18.4978C16.4474 18.9479 15.8369 19.2008 15.2004 19.2008H8.80039C8.16387 19.2008 7.55342 18.9479 7.10333 18.4978C6.65325 18.0477 6.40039 17.4373 6.40039 16.8008V12.0008C6.40013 11.5043 6.55388 11.0199 6.84044 10.6144C7.127 10.2089 7.53227 9.90229 8.00039 9.73678V8.80078C8.00039 7.73992 8.42182 6.7225 9.17196 5.97235C9.92211 5.22221 10.9395 4.80078 12.0004 4.80078C13.0613 4.80078 14.0787 5.22221 14.8288 5.97235C15.579 6.7225 16.0004 7.73992 16.0004 8.80078ZM9.60039 8.80078C9.60039 8.16426 9.85325 7.55381 10.3033 7.10372C10.7534 6.65364 11.3639 6.40078 12.0004 6.40078C12.6369 6.40078 13.2474 6.65364 13.6974 7.10372C14.1475 7.55381 14.4004 8.16426 14.4004 8.80078V9.60078H9.60039V8.80078Z",
    fill: "#B39559"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLock);
export default __webpack_public_path__ + "static/media/golden-lock.2bfda588c990c7dc3b349295fbe943bd.svg";
export { ForwardRef as ReactComponent };